import axios from 'axios';

export default {

  async search() {
    return axios.get('/api/v1/service-types');
  },

};
